import { useEffect, useRef, useState } from "react"
import { useStation } from "@/app/store"
import LoadedImg from "@/app/components/LoadedImg"
import Button from "@/app/components/Button"
import classNames from "classnames"

export default function BgSelector(props: {setImgSrc: Function}) {

    const { setImgSrc } = props
    const routes = useStation().data.filter((s: any) => s.shortcut !== 'STORE')
    const [ active, setActive ] = useState(routes[0]?.shortcut)
    const buttonRefs = useRef<{[key: string]: HTMLDivElement}>({})
    const activeTimeout = useRef<NodeJS.Timeout>(null)

    useEffect(() => {
        return () => {
            clearTimeout(activeTimeout.current)
        }
    }, [])

    useEffect(() => {
        clearTimeout(activeTimeout.current)
        buttonRefs.current?.[active]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        })
        setImgSrc(routes.find((s: any) => s.shortcut === active)?.meta?.carousel_image_url)

        activeTimeout.current = setTimeout(() => {
            handleNextActive()
        }, 8000)
    }, [active])

    const handleNextActive = () => {
        const activeIndex = routes.indexOf(routes.find((s: any) => s.shortcut === active))
        if (activeIndex >= routes.length - 1) {
            setActive(routes[0]?.shortcut)
        }
        else {
            setActive(routes[activeIndex + 1]?.shortcut)
        }
    }

    return (
        <div className="flex items-center gap-3 w-fit p-[--page-padding] py-0">
            { routes.map((route: any, index: number) => (
                // console.log('route: ', route),
                <div
                    key={`bg-selector-${route.shortcut}`}
                    ref={(el) => {buttonRefs.current[route.shortcut] = el}}
                >
                    <Button
                        className={classNames('flex-center gap-2 pe-4 rounded-full transition', {
                            'bg-main-600': active === route.shortcut,
                            'bg-white/80 backdrop-blur-[3.5px]': active !== route.shortcut,
                        })}
                        onClick={(() => {
                            setActive(route.shortcut)
                        })}
                    >
                        <LoadedImg
                            containerClassName={classNames('w-[2.875rem] aspect-square rounded-full border border-[2px] transition-all overflow-hidden', {
                                'border-main-600': active === route.shortcut,
                                'border-white': active !== route.shortcut
                            })}
                            src={route.meta?.carousel_image_url}
                            priority={index === 0 ? 'high' : undefined}
                        />
                        <div className={classNames('whitespace-nowrap text-[0.875rem] font-bold transition', {
                            'text-white': active === route.shortcut,
                            'text-black/50': active !== route.shortcut
                        })}>
                            {route.name}
                        </div>
                    </Button>
                </div>
            ))}
        </div>
    )
}